"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Disclaimer = require("./Disclaimer");
Object.keys(_Disclaimer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Disclaimer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Disclaimer[key];
    }
  });
});